import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSession } from '../api/session';
import { ApiCallError } from '../api/client';

export function LoginPage() {
  const { login } = useSession();
  const navigate = useNavigate();
  const [inviteCode, setInviteCode] = useState('');
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setPending(true);
    try {
      await login(inviteCode.trim());
      navigate('/feed', { replace: true });
    } catch (err) {
      if (err instanceof ApiCallError && err.status === 401) {
        setError('Λάθος invite code.');
      } else {
        setError(`Σφάλμα: ${(err as Error).message}`);
      }
    } finally {
      setPending(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <form
        onSubmit={onSubmit}
        className="w-full max-w-sm rounded-lg border border-slate-200 bg-white p-6 shadow-sm"
      >
        <div className="mb-5 flex items-center gap-2">
          <span className="text-lg font-bold text-rose-600">●</span>
          <span className="text-lg font-semibold text-slate-900">
            AuctionRadar
          </span>
        </div>
        <label
          className="mb-1 block text-xs font-medium uppercase tracking-wide text-slate-500"
          htmlFor="inviteCode"
        >
          Invite code
        </label>
        <input
          id="inviteCode"
          type="text"
          autoFocus
          autoComplete="off"
          value={inviteCode}
          onChange={(e) => setInviteCode(e.target.value)}
          className="w-full rounded border border-slate-300 bg-white px-3 py-2 font-mono text-sm focus:border-slate-900 focus:outline-none"
          placeholder="abc123…"
          disabled={pending}
          required
          minLength={4}
          maxLength={64}
        />
        {error && (
          <p className="mt-2 rounded border border-rose-200 bg-rose-50 px-2 py-1 text-xs text-rose-800">
            {error}
          </p>
        )}
        <button
          type="submit"
          disabled={pending || inviteCode.trim().length < 4}
          className="mt-4 w-full rounded bg-slate-900 px-3 py-2 text-sm font-medium text-white hover:bg-slate-700 disabled:opacity-40"
        >
          {pending ? 'Σύνδεση…' : 'Σύνδεση'}
        </button>
        <p className="mt-3 text-center text-xs text-slate-400">
          Με πρόσκληση μόνο.
        </p>
      </form>
    </div>
  );
}
